







import { useState, useRef } from "react";
import toast from "react-hot-toast";
import {
  bulkUploadDocumentsApi,
  uploadDocumentApi,
  getUserDocumentsApi,
  deleteDocumentApi,
} from "../../app/api";
import { Eye, Trash2 } from "lucide-react";


const IMAGE_BASE_URL = "https://uptask.visiontrek.io/";

const DOCUMENT_TYPES = [
  "AADHAAR",
  "PAN",
  "GRADUATION",
  "MASTERS",
  // "BACHELORS",
  "EXPERIENCE",
  "OTHER",
];

const MAX_SIZE = 5 * 1024 * 1024;

const ALLOWED_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export default function UploadDocuments() {
  const [documents, setDocuments] = useState({});
  const [loading, setLoading] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);
  const [myDocuments, setMyDocuments] = useState([]);
  const [backendError, setBackendError] = useState("");


  const docsRef = useRef(null);

  const handleFileSelect = (e, type) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > MAX_SIZE) {
      toast.error("File must be under 5MB");
      return;
    }

    if (!ALLOWED_TYPES.includes(file.type)) {
      toast.error("Invalid file type");
      return;
    }

    setDocuments((prev) => ({
      ...prev,
      [type]: file,
    }));
  };

  const removeDocument = (type) => {
    setDocuments((prev) => {
      const updated = { ...prev };
      delete updated[type];
      return updated;
    });
  };

  const handleSubmit = async () => {
    const entries = Object.entries(documents);

    if (!entries.length) {
      toast.error("Upload at least one document");
      return;
    }

    try {
      setLoading(true);
      setBackendError("");

      if (entries.length === 1) {
        const [type, file] = entries[0];

        const fd = new FormData();
        fd.append("file", file);
        fd.append("document_type", type);

        const res = await uploadDocumentApi(fd);
        if (!res.success && res.status === 413) {
          setBackendError("File too large. Please upload files under 50KB for best results.");
          toast.error("File size exceeds server limit.");
          return;
        }
      } else {
        const fd = new FormData();

        // entries.forEach(([type, file]) => {
        //   fd.append(type.toLowerCase(), file);
        // });



        entries.forEach(([type, file]) => {
          const field = type.toLowerCase();

          // const allowed = [
          //   "aadhaar",
          //   "pan",
          //   "graduation",
          //   "masters",
          //   "bachelors",
          //   "experience"
          // ];

          const allowed = [
            "aadhaar",
            "pan",
            "graduation",
            "masters",
            "experience",
            "other"
          ];



          if (allowed.includes(field)) {
            fd.append(field, file);
          }
        });


        const res = await bulkUploadDocumentsApi(fd);
        if (!res.success && res.status === 413) {
          setBackendError("One or more files are too large. Max 50KB per file suggested.");
          toast.error("Content too large.");
          return;
        }
      }

      toast.success("Uploaded successfully");

      setDocuments({});
      loadMyDocuments();

    } catch (err) {
      console.error("Upload error:", err);
      if (err.response?.status === 413 || err.message?.includes("413")) {
        setBackendError("413: Content too large. Please compress your images (max 50KB recommended).");
      }
      toast.error(err.message || "Upload failed");
    } finally {
      setLoading(false);
    }
  };

  const loadMyDocuments = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const userId = user?.id;

      if (!userId) return;

      const res = await getUserDocumentsApi(userId);

      if (res?.success) {
        setMyDocuments(res.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center w-full md:mt-20">

      {/* MAIN CARD */}
      <div className="
      w-full
      bg-gradient-to-br
      from-[#2B195C]
      via-[#0e1c2e]
      to-[#2B195C]
      rounded-3xl
      p-6 sm:p-10
      border border-white/10
      shadow-[0_20px_60px_rgba(0,0,0,0.8)]
      ">

        {/* HEADER */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-10">

          <h2 className="text-3xl font-bold text-white">
            Upload Documents
          </h2>

          <button
            // onClick={() => {
            //   setShowDocuments(!showDocuments);
            //   if (!showDocuments) loadMyDocuments();
            // }}

            onClick={() => {
              const next = !showDocuments;
              setShowDocuments(next);

              if (next) {
                loadMyDocuments();

                setTimeout(() => {
                  docsRef.current?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }, 200);
              }
            }}
            className="
            bg-white/10
            px-5 py-2
            rounded-xl
            text-white
            hover:bg-white/20
            transition
            "
          >
            {showDocuments ? "Back" : "View Documents"}
          </button>

        </div>

        {/* DOCUMENT GRID */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

          {DOCUMENT_TYPES.map((type) => {

            const file = documents[type];

            return (

              <div
                key={type}
                className="
                bg-gradient-to-br
                from-[#0f1c2e]
                to-[#0a1423]
                p-6
                rounded-2xl
                border border-white/10
                shadow-[0_10px_40px_rgba(0,0,0,0.6)]
                hover:shadow-[0_20px_60px_rgba(0,0,0,0.9)]
                transition
                "
              >

                <h3 className="text-blue-300 font-semibold mb-4">
                  {type}
                </h3>

                <label className="
                cursor-pointer
                block
                border border-dashed
                border-blue-400/40
                rounded-xl
                p-8
                text-center
                bg-[#0c1828]
                hover:border-blue-400
                hover:bg-[#11243c]
                transition
                ">

                  <input
                    type="file"
                    onChange={(e) => handleFileSelect(e, type)}
                    className="hidden"
                  />

                  {!file ? (

                    <div className="flex flex-col items-center gap-2 text-gray-400">

                      <div className="
                      w-12 h-12
                      flex items-center justify-center
                      rounded-full
                      bg-[#13263f]
                      shadow-inner
                      text-xl
                      ">
                        ☁
                      </div>

                      <p className="text-sm">
                        Drag file or <span className="text-blue-400">browse</span>
                      </p>

                      <p className="text-xs opacity-60">
                        PDF JPG PNG DOCX
                      </p>

                    </div>

                  ) : (

                    <div className="
                    flex items-center justify-between
                    bg-[#0e2036]
                    p-3
                    rounded-xl
                    border border-white/10
                    ">

                      <div className="flex items-center gap-3">

                        <div className="
                        w-10 h-10
                        rounded-lg
                        bg-red-500
                        flex items-center justify-center
                        text-white text-xs font-bold
                        ">
                          PDF
                        </div>

                        <span className="text-white text-sm truncate max-w-[150px]">
                          {file.name}
                        </span>

                      </div>

                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          removeDocument(type);
                        }}
                        className="text-red-400 hover:text-red-300 text-lg"
                      >
                        ✕
                      </button>

                    </div>

                  )}

                </label>

              </div>

            );

          })}

        </div>

        {/* ERROR MESSAGE DISPLAY */}
        {backendError && (
          <div className="mt-6 p-4 bg-red-500/20 border border-red-500/50 rounded-xl text-red-200 text-center animate-pulse">
            <p className="text-sm font-medium">⚠️ {backendError}</p>
          </div>
        )}

        {/* SUBMIT BUTTON */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className="
          mt-10
          w-full
          bg-gradient-to-r
          from-blue-500
          to-blue-600
          py-4
          rounded-xl
          text-white
          font-semibold
          shadow-lg
          hover:scale-[1.02]
          hover:shadow-[0_10px_30px_rgba(0,0,0,0.6)]
          transition
          "
        >
          {loading ? "Uploading..." : "Attach Files"}
        </button>

        {/* VIEW DOCUMENTS */}
        {showDocuments && (

          <div
            ref={docsRef}
            className="mt-10 bg-white/5 p-6 rounded-2xl">

            <h3 className="text-xl font-semibold text-white mb-6">
              My Uploaded Documents
            </h3>

            {myDocuments.length === 0 ? (

              <p className="text-gray-400">
                No documents uploaded yet
              </p>

            ) : (

              <div className="space-y-4">

                {myDocuments.map((doc) => (

                  <div
                    key={doc.id}
                    className="
                    flex flex-col sm:flex-row justify-between items-start sm:items-center
                    bg-[#0e2036]
                    p-4
                    rounded-xl
                    border border-white/10
                    gap-4
                    "
                  >

                    <div>

                      <p className="text-white font-medium">
                        {doc.document_type}
                      </p>

                      <p className="text-gray-400 text-sm">
                        {doc.file_name}
                      </p>

                    </div>






                    <div className="flex gap-2 self-end sm:self-auto">

                      {/* VIEW */}
                      <a
                        href={`${IMAGE_BASE_URL}${doc.file_path}`}
                        target="_blank"
                        rel="noreferrer"
                        className="
    w-9 h-9
    flex items-center justify-center
    rounded-lg
    bg-blue-500/80
    hover:bg-blue-500
    text-white
    transition
    "
                      >
                        <Eye size={16} />
                      </a>

                      {/* DELETE */}
                      <button
                        onClick={async () => {
                          await deleteDocumentApi(doc.id);
                          loadMyDocuments();
                        }}
                        className="
    w-9 h-9
    flex items-center justify-center
    rounded-lg
    bg-red-500/80
    hover:bg-red-500
    text-white
    transition
    "
                      >
                        <Trash2 size={16} />
                      </button>

                    </div>


                  </div>

                ))}

              </div>

            )}

          </div>

        )}

      </div>

    </div>
  );
}






